import Link from "next/link";

const TermsOfService = () => {
  return (
    <div className=" bg-white p-4 sm:p-8">
      <div className="mx-auto max-w-4xl  p-6 text-[20px]  text-[#101828]  sm:p-8">
        <div className="mb-6  pb-4 text-center">
          <p className="text-sm text-gray-500">Current as of 20 Jan 2024</p>
          <h1 className="mt-2 text-2xl font-semibold text-gray-800 sm:text-3xl">
            Terms of Use
          </h1>
        </div>
        <div className="mb-8">
          <h1 className="mb-4 text-3xl font-bold text-[#101828]">
            1. Introduction
          </h1>
          <p className="mb-4 leading-relaxed">
            These terms of use (“<strong>Terms</strong>” or “
            <strong>Agreement</strong>”) set forth the general terms and
            conditions of your use of our website and all related mobile
            applications (“<strong>Website</strong>”, “<strong>Platform</strong>
            ”). This Agreement is legally binding between you (“
            <strong>You</strong>”, or “<strong>Your</strong>”) and ThriveAgric
            Limited (“<strong>ThriveAgric</strong>”, “<strong>We</strong>”, “
            <strong>Us</strong>” or “<strong>Our</strong>”).
          </p>
          <p className="leading-relaxed">
            By accessing and using the Website, You acknowledge that You have
            read, understood, and agree to be bound by this Agreement. You must
            be at least the age of majority in Your state or country of
            residence.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold text-[#101828]">
            2. Information about Us
          </h2>
          <p className="leading-relaxed">
            This Website is operated by ThriveAgric Limited. We are registered
            in Nigeria with registration number 1416843 and have our registered
            office at 31, 441 Crescent CITEC Villas, Gwarinpa, Abuja, Nigeria.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold text-[#101828]">
            3. Your Use of Our Website
          </h2>
          <ol className="ml-6 list-decimal space-y-4">
            <li>
              This Website enables farmers to secure input financing and access
              opportunities for off-taker financing.
            </li>
            <li>
              You may need to create an online profile and account to fully
              access the services available via the Website.
            </li>
            <li>
              Our use of personal information submitted to Us is governed by our{" "}
              <Link href="/privacy" className="text-[#48A928] underline">
                Privacy Policy
              </Link>
              .
            </li>
            <li>
              You must inform Us immediately of any changes to Your personal
              information.
            </li>
            <li>
              You are the only person permitted to use Your username and
              password.
            </li>
            <li>
              If you suspect misuse, notify Us immediately via
              <a
                href="mailto:info@thriveagric.com"
                className="ml-1 text-[#48A928] underline"
              >
                info@thriveagric.com
              </a>
              .
            </li>
          </ol>
        </div>

        <div>
          <h2 className="mb-4 text-2xl font-bold text-[#101828]">
            4. Acceptable Use Restrictions
          </h2>
          <ol className="ml-6 list-decimal space-y-4">
            <li>
              You shall not use the Website in any unlawful manner, for any
              unlawful purpose, or in any manner inconsistent with this
              Agreement.
            </li>
            <li>
              You shall not connive with ThriveAgric’s employees or customers to
              use the Website unlawfully.
            </li>
            <li>You shall not create multiple profiles or use proxies.</li>
            <li>You shall not use the Website to make payments for debts.</li>
            <li>
              You shall not use the Platform for pyramid schemes or illegal
              promotions.
            </li>
            <li>You shall not infringe on intellectual property rights.</li>
            <li>
              You shall not damage, disable, overburden, impair, or compromise
              Our systems.
            </li>
            <li>
              You must report breaches or violations by contacting us at
              <a
                href="mailto:info@thriveagric.com"
                className="ml-1 text-[#48A928] underline"
              >
                info@thriveagric.com
              </a>
              .
            </li>
          </ol>
        </div>
        <div className="mb-6   ">
          <h2 className="mb-4 text-xl font-bold text-gray-800">
            5. Taxes & Transaction Charges
          </h2>
          <ol className="list-decimal space-y-2 pl-6 text-gray-700">
            <li>
              Please note that You may be required to pay transaction charges,
              fees, and applicable taxes...
            </li>
            <li>
              By using any service made available to You under this Agreement...
            </li>
            <li>
              If you fail to pay any such transaction charges, fees, or taxes...
            </li>
            <li>
              We may increase any such transaction charges, including any
              amounts...
            </li>
            <li>All transaction charges, fees, and other amounts payable...</li>
          </ol>
        </div>

        <div className="mb-6   ">
          <h2 className="mb-4 text-xl font-bold text-gray-800">
            6. Linking to Our Website
          </h2>
          <ol className="list-decimal space-y-2 pl-6 text-gray-700">
            <li>
              You may link to Our home page, provided You do so in a way...
            </li>
            <li>
              You must not establish a link in such a way to suggest any...
            </li>
            <li>
              You must not establish a link to the Website in any website...
            </li>
            <li>The Website must not be framed on any other site...</li>
            <li>If You wish to make use of any content on the Website...</li>
          </ol>
        </div>

        <div className="mb-6   ">
          <h2 className="mb-4 text-xl font-bold text-gray-800">
            7. Intellectual Property Rights & Confidentiality
          </h2>
          <ol className="list-decimal space-y-2 pl-6 text-gray-700">
            <li>
              Notwithstanding any other provision in this Agreement, ThriveAgric
              shall remain the exclusive owner...
            </li>
            <li>
              You hereby agree not to reproduce, duplicate, copy, sell, resell
              or exploit any portion...
            </li>
          </ol>
        </div>
        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">
            8.Processing of Personal Data
          </h2>
          <ol className="list-decimal space-y-2 pl-6">
            <li>
              Any personal information that comes into Your possession while
              performing Your obligations under this Agreement must be processed
              in accordance with the Nigeria Data Protection Act 2023 or any
              amendments thereto.
            </li>
            <li>
              You will ensure to have all necessary and appropriate consents and
              notices in place to enable, where necessary, lawful transfer of
              personal data to Us for the duration and purposes of this Terms.
            </li>
            <li>
              You shall ensure that You have in place appropriate technical and
              organisational measures, to protect against unauthorised or
              unlawful processing of personal data and against accidental loss
              or destruction of, or damage to, personal data, appropriate to the
              harm that might result from the unauthorised or unlawful
              processing or accidental loss, destruction or damage and the
              nature of the data to be protected.
            </li>
          </ol>
        </div>
        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">
            9. Disclaimer and Limitation of Liability
          </h2>
          <ol className="list-decimal space-y-2 pl-6">
            <li>
              You assume all responsibility and risk with respect to Your use of
              the Website, which is provided “as is” and “as available” without
              warranties, representations or conditions of any kind...
            </li>
            <li>
              The use of the Website is at Your sole risk and You assume full
              responsibility for any costs associated with Your use of the
              Website. We will not be liable for any damages of any kind related
              to the use of the Website.
            </li>
            <li>
              In no event will We, or Our affiliates, Our or their respective
              content or service providers, or any of Our or their respective
              directors, officers, agents, contractors...
            </li>
          </ol>
        </div>
        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">10. Indemnification</h2>
          <p>
            You agree to defend and indemnify ThriveAgric, and hold ThriveAgric
            and its affiliates, directors, officers, agents, contractors, and
            employees harmless against any losses, liabilities, claims, expenses
            (including legal fees) in any way arising from...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">11. Entire Agreement</h2>
          <p>
            Except as otherwise notified to You by ThriveAgric, the Agreement
            and any documents expressly referred to in them represent the entire
            agreement between You and Us...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">12. Waiver</h2>
          <p>
            Our failure to exercise or enforce any right or provision of the
            Terms will not constitute a waiver of such right or provision. A
            waiver by Us of any default will not constitute...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">13. Headings</h2>
          <p>Any headings and titles herein are for convenience only.</p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">14. Severability</h2>
          <p>
            If any of the provisions of the Terms are determined by any
            competent authority to be invalid, unlawful, or unenforceable, such
            provision will to that extent be severed...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">15. Force Majeure</h2>
          <p>
            ThriveAgric shall not be in breach of this Agreement nor liable for
            delay in performing, or failure to perform, any of its obligations
            under this Terms if such delay or failure...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">16. Assignment</h2>
          <p>
            You shall not assign, transfer or novate any of Your rights and
            obligations under this Terms of Use, if any, without our written
            consent.
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">
            17. No Partnership or Agency
          </h2>
          <p>
            This Agreement shall not be construed as creating any partnership,
            joint venture, agency or similar relationship between You and
            ThriveAgric other than the relationship with respect...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">
            18. Governing Law & Dispute Resolution
          </h2>
          <p>
            Any disputes arising out of or relating to the Agreement, the
            Privacy Policy, or use of the Website will be resolved in accordance
            with the laws of the Federal Republic of Nigeria...
          </p>
        </div>

        <div className="mb-8">
          <h2 className="mb-4 text-2xl font-bold">19. Questions or Concerns</h2>
          <p>
            Please send all questions, comments, and feedback to us at{" "}
            <a
              href="mailto:info@thriveagric.com"
              className="text-[#48A928] underline"
            >
              info@thriveagric.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
